import { BasePlugin } from '../base'
import mdcLinearProgress from './mdc-linear-progress.vue'

export { mdcLinearProgress }

export default BasePlugin({
  mdcLinearProgress
})
